import get from "lodash/get";

import { Listings } from "../../../../api/api-listings";
import * as types from "../constants/action-types";

const fetchListingsRequest = () => {
  return {
    type: types.LISTINGS_FETCH_REQUEST,
  };
};

const fetchListingsSuccess = (data) => {
  return {
    type: types.LISTINGS_FETCH_SUCCESS,
    data,
  };
};

const fetchListingsFailure = (fetchError) => {
  return {
    type: types.LISTINGS_FETCH_FAILURE,
    fetchError,
  };
};

const clearListingsData = () => {
  return {
    type: types.LISTINGS_CLEAR_STORE,
    data: [],
  };
};

// fetch listings by space

const fetchListingsBySpaceRequest = () => {
  return {
    type: types.LISTINGS_FETCH_BY_SPACE_REQUEST,
  };
};

const fetchListingsBySpaceSuccess = (data) => {
  return {
    type: types.LISTINGS_FETCH_BY_SPACE_SUCCESS,
    data,
  };
};

const fetchListingsBySpaceFailure = (fetchError) => {
  return {
    type: types.LISTINGS_FETCH_BY_SPACE_FAILURE,
    fetchError,
  };
};

export const fetchOwnerListingsInfo = (query) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(fetchListingsRequest());
      return Listings.queryListings(query, (response) => {
        if (200 === response.statusCode) {
          const listings = get(response, "listings", []);
          dispatch(fetchListingsSuccess(listings));
          return resolve(listings);
        }

        const fetchError = get(response, "error", "");
        dispatch(fetchListingsFailure(fetchError));
        return reject(fetchError);
      });
    });
  };
};

const fetchListingsByOwnerSpacesSuccess = (data, spaceIds) => {
  return {
    type: types.LISTINGS_FETCH_BY_OWNER_SPACES_SUCCESS,
    data,
    spaceIds,
  };
};

const queryOwnerSpaceListings = (SSOid, spaceId) => {
  return new Promise((resolve, reject) => {
    Listings.queryListings(
      `owner/${SSOid}?full=true&parent_space_id=${spaceId}`,
      (response) => {
        if (200 === response.statusCode) {
          return resolve(get(response, "listings", []));
        }
        return reject(get(response, "error", ""));
      },
    );
  });
};

/**
 * Fetches an owner's listings for the given spaces only, one request per space.
 * On success it replaces just those spaces' listings in the store, so the
 * My Listings page loads the listings for its current page of spaces rather
 * than every listing the host owns.
 */
export const fetchOwnerListingsBySpaceIds = ({ SSOid, spaceIds }) => {
  return (dispatch) => {
    dispatch(fetchListingsRequest());
    return Promise.all(
      spaceIds.map((spaceId) => queryOwnerSpaceListings(SSOid, spaceId)),
    )
      .then((listingsBySpace) => {
        const listings = listingsBySpace.flat();
        dispatch(fetchListingsByOwnerSpacesSuccess(listings, spaceIds));
        return listings;
      })
      .catch((fetchError) => {
        dispatch(fetchListingsFailure(fetchError));
        throw fetchError;
      });
  };
};

export const fetchListingsBySpace = (spaceID) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(fetchListingsBySpaceRequest());
      return Listings.readBySpaceID(spaceID, (response) => {
        if (200 === response.statusCode) {
          const listings = get(response, "listings", []);
          dispatch(fetchListingsBySpaceSuccess(listings));
          return resolve(listings);
        }

        const fetchError = get(response, "error", "");
        dispatch(fetchListingsBySpaceFailure(fetchError));
        return reject(fetchError);
      });
    });
  };
};

export const clearListingsStore = () => {
  return (dispatch) => {
    dispatch(clearListingsData());
  };
};
